import { API_BASE_URL } from "../config/apiBaseUrl";
import { parseDealerPortalApiResponse } from "../utils/dealerPortalApiError.js";

const ADMIN_BASE = "/api/admin/automotive";
const PORTAL_BASE = "/api/v1/automap/dealer-portal";
const PUBLIC_BASE = "/api/v1/automap";

function authHeaders() {
  return { credentials: "include", headers: { "Content-Type": "application/json" } };
}

function qs(params = {}) {
  const search = new URLSearchParams();
  Object.entries(params).forEach(([k, v]) => {
    if (v != null && v !== "") search.set(k, v);
  });
  const q = search.toString();
  return q ? `?${q}` : "";
}

export async function fetchPlansDashboard() {
  const res = await fetch(`${API_BASE_URL}${ADMIN_BASE}/plans/dashboard`, authHeaders());
  if (!res.ok) throw new Error("No se pudo cargar planes.");
  return res.json();
}

export async function fetchPlanDealers(filters = {}) {
  const res = await fetch(`${API_BASE_URL}${ADMIN_BASE}/plans/dealers${qs(filters)}`, authHeaders());
  if (!res.ok) throw new Error("No se pudo cargar concesionarios por plan.");
  return res.json();
}

export async function fetchPlanFeatures() {
  const res = await fetch(`${API_BASE_URL}${ADMIN_BASE}/plans/features`, authHeaders());
  if (!res.ok) throw new Error("No se pudo cargar matriz de planes.");
  return res.json();
}

export async function fetchAdminDealerPlan(dealerId) {
  const res = await fetch(`${API_BASE_URL}${ADMIN_BASE}/dealers/${encodeURIComponent(dealerId)}/plan`, authHeaders());
  if (!res.ok) throw new Error("No se pudo cargar plan del concesionario.");
  return res.json();
}

export async function assignDealerPlan(dealerId, body) {
  const res = await fetch(`${API_BASE_URL}${ADMIN_BASE}/dealers/${encodeURIComponent(dealerId)}/plan/assign`, {
    method: "POST",
    ...authHeaders(),
    body: JSON.stringify(body),
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.error || "No se pudo asignar plan.");
  }
  return res.json();
}

export async function changeDealerPlan(dealerId, body) {
  const res = await fetch(`${API_BASE_URL}${ADMIN_BASE}/dealers/${encodeURIComponent(dealerId)}/plan/change`, {
    method: "POST",
    ...authHeaders(),
    body: JSON.stringify(body),
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.error || "No se pudo cambiar plan.");
  }
  return res.json();
}

export async function suspendDealerPlan(dealerId, reason) {
  const res = await fetch(`${API_BASE_URL}${ADMIN_BASE}/dealers/${encodeURIComponent(dealerId)}/plan/suspend`, {
    method: "POST",
    ...authHeaders(),
    body: JSON.stringify({ reason }),
  });
  if (!res.ok) throw new Error("No se pudo suspender plan.");
  return res.json();
}

export async function cancelDealerPlan(dealerId, reason) {
  const res = await fetch(`${API_BASE_URL}${ADMIN_BASE}/dealers/${encodeURIComponent(dealerId)}/plan/cancel`, {
    method: "POST",
    ...authHeaders(),
    body: JSON.stringify({ reason }),
  });
  if (!res.ok) throw new Error("No se pudo cancelar plan.");
  return res.json();
}

export async function updateCustomPlanLimits(dealerId, body) {
  const res = await fetch(`${API_BASE_URL}${ADMIN_BASE}/dealers/${encodeURIComponent(dealerId)}/plan/custom-limits`, {
    method: "POST",
    ...authHeaders(),
    body: JSON.stringify(body),
  });
  if (!res.ok) throw new Error("No se pudo actualizar límites.");
  return res.json();
}

export async function updateDealerPlanBilling(dealerId, billingStatus) {
  const res = await fetch(`${API_BASE_URL}${ADMIN_BASE}/dealers/${encodeURIComponent(dealerId)}/plan/billing`, {
    method: "POST",
    ...authHeaders(),
    body: JSON.stringify({ billingStatus }),
  });
  if (!res.ok) throw new Error("No se pudo actualizar billing.");
  return res.json();
}

export async function addDealerPlanNote(dealerId, body) {
  const res = await fetch(`${API_BASE_URL}${ADMIN_BASE}/dealers/${encodeURIComponent(dealerId)}/plan/notes`, {
    method: "POST",
    ...authHeaders(),
    body: JSON.stringify(body),
  });
  if (!res.ok) throw new Error("No se pudo agregar nota.");
  return res.json();
}

export async function convertTrialToPlan(dealerId, body) {
  const res = await fetch(`${API_BASE_URL}${ADMIN_BASE}/dealers/${encodeURIComponent(dealerId)}/plan/convert-trial`, {
    method: "POST",
    ...authHeaders(),
    body: JSON.stringify(body),
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.error || "No se pudo convertir trial.");
  }
  return res.json();
}

export async function fetchDealerPlanPortal(dealerId) {
  const res = await fetch(`${API_BASE_URL}${PORTAL_BASE}/dealers/${encodeURIComponent(dealerId)}/plan`, authHeaders());
  if (!res.ok) throw new Error("No se pudo cargar tu plan.");
  return res.json();
}

export async function requestDealerPlanUpgrade(dealerId, body) {
  const res = await fetch(
    `${API_BASE_URL}${PORTAL_BASE}/dealers/${encodeURIComponent(dealerId)}/plan/upgrade-request`,
    {
      method: "POST",
      ...authHeaders(),
      body: JSON.stringify(body),
    }
  );
  return parseDealerPortalApiResponse(res, { defaultCode: "submitUpgrade" });
}

export async function fetchPublicPlanComparison() {
  const res = await fetch(`${API_BASE_URL}${PUBLIC_BASE}/plans/comparison`);
  if (!res.ok) throw new Error("No se pudo cargar planes.");
  return res.json();
}
